export default __webpack_public_path__ + "static/media/blue.e19a11eb.png";